import { Link } from "react-router-dom";


const Footer = () => {



    return (
        <>
            <section className="CTA2 position-relative p-md-0 pb-0 pt-5 pt-md-0 overflow-hidden">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="affiliate_prog">
                                <h4 className="text-white">Welcome to our Affiliate Program</h4>
                                <p className="text-white">Connect and earn now!</p>
                                <a href="/simfly-new-partner-platform" className="mybtn secondary-bg text-dark">Join Us Now</a>
                            </div>
                        </div>
                        <div className="col-md-6 h-100">
                            <div className="affiliate_video">
                                <iframe width="100%" height="350px" src="https://www.youtube.com/embed/Xy0fCNsh6ko?si=zvuOinv0iTY2ygGc&autoplay=1&loop=1&mute=1&playlist=Xy0fCNsh6ko" allowFullScreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer>
                <div className="container">
                    <div className="row pb-5 justify-content-between">
                        <div className="col-md-3">
                            <a className="navbar-brand fw-bold fs-2 primary-text p-0 mb-3" href="#"><img src='./assets/images/logo_final.svg' alt='logo' /></a>
                            <p>With Simfly&rsquo;s eSIM, enjoy internet connection on every adventure and forget about expensive roaming
                                bills upon your return. </p>
                        </div>
                        <div className="col-md-2">
                            <h5>Popular Countries</h5>
                            <div className="links">
                                <a target="_blank" rel="noreferrer" href="https://simfly.biz/esim-plans/united-states">United States</a>
                                <a target="_blank" rel="noreferrer" href="https://simfly.biz/esim-plans/united-kingdom">United Kingdom</a>
                                <a target="_blank" rel="noreferrer" href="https://simfly.biz/esim-plans/turkey">Turkey</a>
                                <a target="_blank" rel="noreferrer" href="https://simfly.biz/esim-plans/canada">Canada</a>
                                <a target="_blank" rel="noreferrer" href="https://simfly.biz/esim-plans/australia">Australia</a>
                                <a target="_blank" rel="noreferrer" href="https://simfly.biz/esim-plans/saudi-arabia">Saudi Arabia</a>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <h5>About us</h5>
                            <div className="links">
                                <Link to="/aboutus" target="_blank" >About Simfly</Link>
                                <Link to="/term-and-conditions" target="_blank" >Terms & Conditions</Link>
                                <Link to="/refund-policy" target="_blank" >Refund Policy</Link>
                                <a target="_blank" href="https://simfly.biz/blog/">Our Blogs</a>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <h5>More Info</h5>
                            <div className="links">
                                <Link to="/simfly-new-partner-platform">Partner with us</Link>
                                <Link to="/contactus">Contact Us</Link>
                                <Link to="/privacy-cookie-policy">Privacy & Cookie Policy</Link>
                                <Link>EULA</Link>

                            </div>
                            <div className="my-3 d-flex align-items-center social_links justify-md-content-end justify-content-center gap-4 order-md-3 order-2 text-end">
                                <a href="https://www.facebook.com/people/Simfly/61571718781416/" target="_blank" rel="noreferrer">
                                    <img src="./assets/images/facebook.svg" alt="" />
                                </a>
                                <a href="https://www.instagram.com/simfly_biz/" target="_blank" rel="noreferrer"> <img src="./assets/images/instagram.svg" alt="" /></a>
                                <a href="https://www.pinterest.com/simfly_biz/" target="_blank" rel="noreferrer"><img src="./assets/images/pinterest.svg" alt="" /></a>
                                <a href="https://www.youtube.com/@simfly_biz" target="_blank" rel="noreferrer"> <img src="./assets/images/youtube.svg" alt="" /></a>
                                <a href="https://x.com/Simfly_biz" target="_blank" rel="noreferrer"> <img src="./assets/images/twitter.svg" alt="" /></a>
                                <a target="_blank" href="https://www.linkedin.com/company/simfly-biz/" rel="noreferrer"> <img src="./assets/images/linkedin.svg" alt="" /></a>
                            </div>
                        </div>
                    </div>
                    <div className="row pt-3 border-top footer_bottom">
                        <div className="col-md-8 d-flex align-items-center order-md-1 justify-content-center justify-content-md-start mt-3 mt-md-0 order-3">
                            <p className="m-0 me-4 small">© 2024 Simfly | &nbsp;Powered by SWASTIKA COMPANY LIMITED</p>
                        </div>
                        <div className="col-md-4 text-md-end order-md-2 order-1 text-center">
                            <img src="./assets/images/payments.webp" className="payment" alt="Payments" />
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;